import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiGetAppUserResponseBody,
  IApiUpdateAppUserRequestBody,
} from '../AppsApi.types';
import { useApi } from '~/lib/api/useApi';
import { appUserQueryKeyFactory } from './useAppUserQuery';
import { appUsersQueryKeyFactory } from './useAppUsersQuery';

export type IUseUpdateAppUserMutationValues = {
  appId: string;
  userId: string;
  body: IApiUpdateAppUserRequestBody;
};

export const useUpdateAppUserMutation = (): UseMutationResult<
  IApiGetAppUserResponseBody,
  unknown,
  IUseUpdateAppUserMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values) =>
      api.apps.updateUser(values.appId, values.userId, values.body),
    onSuccess: async (updatedAppUser, values) => {
      queryClient.setQueryData(appUserQueryKeyFactory(values)!, updatedAppUser);
      await queryClient.invalidateQueries({
        queryKey: appUsersQueryKeyFactory(values),
      });
    },
  });
};
